import { RouteResponse } from '@/api/main/types.gen'

export function getRouteDisplay(routeId: string, routes?: RouteResponse[]): string {
  if (!routes) return routeId
  const route = routes.find(r => r.id === routeId)
  if (route?.name) {
    return route.name
  }
  return routeId
}

export function createRouteNameMap(routes?: RouteResponse[]): Map<string, string | undefined> {
  if (!routes) return new Map<string, string | undefined>()
  const map = new Map<string, string | undefined>()
  for (const route of routes) {
    const key = `${route.id}-${route.version}`
    map.set(key, route.name)
  }
  return map
}
